import { AppSettings, QUERY_KEYS } from '@24i/nxg-sdk-photon/src';
import { useQuery } from 'react-query';
import { useAppSettingsData } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';

export const useAppConfigQuery = () => {
    const { client } = useAppSettingsData();

    const { isLoading, data, refetch } = useQuery<AppSettings>(
        QUERY_KEYS.config,
        client.fetchServiceConfig
    );

    return {
        isLoading,
        appSettings: data,
        refetch,
    };
};
